
<template>
    <div 
        :class="{
            'h-tree-item':true,
        }"
        
        >
        <div id="h-tree-node_node" class="h-tree-node_node" @click="handleToggle($event,expandOnClickNode,'all')">
            <div @click="handleToggle($event,!expandOnClickNode,'arrow')">
                <span v-if="hasChild" class="h-tree-node__expand-icon" >
                    <i :class="open?'el-icon-caret-bottom':'el-icon-caret-right'"></i>
                </span>
                <span v-else class="h-tree-node__expand-icon">
                    <i class="h-icon-empty"></i>
                </span>
            </div>
            <input @click="getChecked(list)" type="checkbox" id="h-checkbox" class="h-checkbox__original" v-show="showCheckbox" />
            <span @click="nodeClick(list)">
                <template v-if="$slots.default">
                    <slot :node="list"></slot>
                </template>
                <template v-else>
                    <span class="h-tree-node_label">{{list[props.label]}}</span>
                </template>
            </span>
        </div>
        <div v-show='open' class="h-tree-item_content">
            <h-tree-item
                v-for="(item, index) in list[props.children]"
                :list="item"
                :key="index"
                :props="props"
                :highlight-current="highlightCurrent"
                :show-checkbox="showCheckbox"
                :expand-on-click-node="expandOnClickNode"
                @node-click="nodeClick"
                :node-key="nodeKey"
                @check-change="checkChange"
            >
                    <!-- <slot></slot> -->
                <!-- <template v-if="$slots.default">
                </template>
                <template v-else>
                    <span class="h-tree-node_label">{{list[props.label]}}</span>
                </template> -->
            </h-tree-item>
        </div>
    </div>
</template>

<script>
// 用于存储勾选数据
let temp = [];
let checkArray = []
export default {
    name: "HTreeItem",
    props: {
        list: {
            type: [Object, Array],
            required: true
        },
        // 树节点参数
        props:{
            type:Object,
        },
        // 是否高亮
        highlightCurrent:{
            type:Boolean,
        },
        // 是否多选
        showCheckbox:{
            type:Boolean,
        },
        expandOnClickNode:{
            type:Boolean,
        },
        nodeKey:{
            type:String,
        }
        
    },
    data() {
        return {
            open: false,
            checkFlag: false,
            checkArray: [],
            isClick:false
        };
    },
    computed: {
        hasChild() {
            return this.list.children && this.list.children.length;
        }
    },
    methods: {
        handleToggle(event,flag,type) {
            if(type == 'all' && this.highlightCurrent){
                
            }
            if(type == 'all'){
                let doc = document.querySelector('.h-tree-node_node')
                doc.classList.add('current-node')
                console.log(event)
            }
            if (this.hasChild && flag) {
                this.open = !this.open;
            }
        },
        nodeClick(node){
            // this.isClick = true
            this.$emit('node-click',node)
            // this.handleToggle(true)
        },
            
        getChecked(node){
            temp.push(node)
            var newArr = []
            //遍历数组
            newArr = temp.filter(function(value,index,self){
                return self.indexOf(value) === index;
            });
            // temp.forEach((v,i)=>{
            //     if(v == node){
            //         temp.splice(i,1)
            //     }
            // })
            this.checkChange(newArr)
        },
        checkChange(node){
            this.$emit('check-change',node)
        }
    }
};
</script>

<style lang='less' scoped>
.h-tree-item{
    .h-tree-item_content{
        padding-left: 10px;
    }
    .h-tree-node_node{
        display: flex;
        align-items: center;
        height: 26px;
        font-size: 14px;
        cursor: pointer;
        .h-checkbox__original{
            border: 1px solid #dcdfe6;
            border-radius: 2px;
            margin-left: 0;
            cursor: pointer;
        }
        &:hover{
            background: #f5f7fa;
        }
        &:focus{
            background: #f5f7fa;
        }
        .h-tree-node__expand-icon{
            padding:0 6px;
            cursor: pointer;
            color: #c0c4cc;
            font-size: 12px;
            transform: rotate(0deg);
            transition: transform .3s ease-in-out;
            .h-icon-empty{
                display: inline-block;
                width: 12px;
                height: 12px;
            }
        }
        .h-tree-node_label{
            height: 26px;
            line-height: 26px;
            font-size: 14px;
            cursor: pointer;
        }
    }
}
.current-node{
    background: #f5f7fa;
}
.highlight-current{
    background: #c6e2ff;
}
.custom-tree-node{

}
</style>

